<template>
  <div class="form-group">
    <label v-if="label" :for="label" :class="labelClass">
      {{ label }} <span v-if="required">*</span>
    </label>
    <div class="position-relative">
      <b-form-input
        :type="inputType"
        :value="displayValue"
        v-bind="$attrs"
        v-on="$listeners"
        :placeholder="placeholder"
        :disabled="disabled"
        :required="required"
        :readonly="(mask && !showReal) || readonly"
        :class="{'is-invalid': invalid}"
      />

      <!-- Icon toggle -->
      <span v-if="mask" class="toggle-visibility" @click="toggleVisibility">
        <i :class="showReal ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BFormInputWithMask",
  inheritAttrs: false,
  props: {
    value: [String, Number],
    placeholder: String,
    disabled: Boolean,
    label: {
      type: String,
      default: null,
    },
    labelClass: {
      type: [String, Object, Array],
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text", // default tetap text
    },
    mask: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      showReal: false,
    };
  },
  computed: {
    displayValue() {
      const val = String(this.value || "");

      // kalau kosong/null → tampilkan apa adanya (tidak mask)
      if (!val) return val;

      // kalau mask=false → tampilkan asli
      if (!this.mask) return val;

      // kalau showReal aktif → tampilkan asli
      if (this.showReal) return val;

      // masking normal (baru jalan kalau isUpdate=true dan ada value)
      return this.maskText(val);
    },
    inputType() {
      // supaya tidak error pada type=number waktu masking
      if (this.mask && !this.showReal && this.value) {
        return "text";
      }
      return this.type || "text";
    },
  },
  methods: {
    toggleVisibility() {
      this.showReal = !this.showReal;
      if (this.callback !== null) {
        this.showReal = this.callback(this.showReal, this.mask);
      }
    },
    maskText(text) {
      if (!text) return "";
      if (text.length <= 2) return text;
      const first = text.charAt(0);
      const last = text.charAt(text.length - 1);
      return first + "*".repeat(text.length - 2) + last;
    },
  },
};
</script>

<style scoped>

/* default posisi untuk semua input */
.toggle-visibility {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
}

/* kalau input type=date, geser lebih kiri biar tidak nutupin icon kalender */
input[type="date"] + .toggle-visibility,
input[type="number"] + .toggle-visibility {
  right: 60px;
}

/* Ensure focus ring shows even for readonly inputs (masked state) */
.form-control:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.is-invalid,
.is-invalid:read-only,
.is-invalid:disabled {
  border: 1px solid #dc3545 !important;
}

.is-invalid:focus {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/masking-input.vue